export enum DialogNames {
  SelectBankAccount = 'selectBankAccount',
  RejectEditedPlan = 'rejectEditedPlan',
  ProposeAlternativePlan = 'proposeAlternativePlan',
  StockOnHand = 'stockOnHand',
  SlowSalesPlanningTip = 'slowSalesPlanningTip',
  SlowSalesResponse = 'slowSalesResponse',
}
